module.exports = __webpack_public_path__ + "assets/img/process.042a3a51.png";